<div class="container">
    <div class="row">
        
    </div>
</div>
<div class="congtainer">
    <div class="row">
        <div class="col-sm" style="text-align: center;">
            <h1>SENSEI EDGAR ALQUINGA</h1>
            <br>
        </div>
    
    </div>
</div>
<div class="row">
    
    <div class="col-sm" style="text-align: center;">
        <img src="../../../assets/img/karate/SENSEI.jpg" style="width: 350px; height: 500px;" alt="">
    </div>
    <div class="col-sm" style="text-align: center;">
        <p>Sensei Edgar Alquinga 4 Dan en KARATE DO estilo SHOTOKAN, con mas de 30 años de experiencia en este estilo.</p>
        <P>La experiencia que posee el sensei son las siguiente: </P>
        <p>Karate Deportivo</p>
        <p>Karate tradicional</p>
        <p>Defensa personal</p>
        <p>Acondicionamiento Físico</p>
        <p>Rutinas de tonificación</p>
        <br>
        <p style="font-style: oblique;">El Karate es como el agua hirviendo, si no lo calientas constantemente, se enfriará. -Gichin Funakashi.</p>
    </div>
    
</div>